<template>
  <div class="pt-root">
    <div class="pt-product-filter">
      <Select
          title="Produto"
          field="productId"
          :formName="formName"
          :required="false"
          :showNewRegister="false"
          url="/api/v1/stock/product/select-all-with-typeProduct"
          v-model="product"
      />
    </div>

    <div class="pt-search-bar">
      <input
          class="pt-search-input"
          type="text"
          placeholder="Código do patrimônio..."
          v-model="barCode"
          @keyup.enter="search"
          :disabled="loading"
      />
      <Button
          _key="search-patrimony"
          classIcon="fa-solid fa-magnifying-glass"
          type="info"
          size="small"
          :disabled="loading || !barCode.trim()"
          :clicked="search"
      />
    </div>

    <Loading v-if="loading" type="line" :center="false"/>

    <div class="pt-empty-state" v-if="!result && !loading && !searched">
      <i class="fa-duotone fa-solid fa-radar pt-empty-icon"></i>
      <p class="pt-empty-text">Digite o patrimônio para ver o histótico.</p>
    </div>

    <Alert type="warning" v-if="searched && result && result.length === 0">
      Nenhum patrimônio encontrado para <strong>{{ barCode }}</strong>.
    </Alert>

    <ScrollBar v-if="result && result.length > 0" :minHeight="100" :maxHeight="520">
      <div class="pt-results-inner">
        <div v-for="group in result" :key="group.barCode + '_' + (group.rentId || (group.patrimonies && group.patrimonies[0] ? group.patrimonies[0].patrimonyId : ''))">
          <Alert type="warning" v-if="group.patrimonies && group.patrimonies.length > 1">
            Código <strong>{{ group.barCode }}</strong> duplicado — {{ group.patrimonies.length }} patrimônios
            encontrados.
          </Alert>

          <div class="pt-card" v-for="patrimony in group.patrimonies" :key="patrimony.patrimonyId">
            <div class="pt-card-header">
              <div class="pt-card-header-left">
                <span class="pt-barcode-pill">
                 {{ patrimony.barCode }}
                </span>
                <span :class="['pt-status-pill', getStatusClass(patrimony.statusName)]">
                  {{ patrimony.statusName }}
                </span>
                <span v-if="patrimony.currentRentNumber" class="pt-tl-rent">
                  Locação Nº {{ patrimony.currentRentNumber }}
                </span>
                <span v-if="group.patrimonies.length > 1" class="pt-sub-label"></span>
                <span v-if="patrimony.statusDivergence" class="pt-divergence-badge">
                  <i class="fa-solid fa-triangle-exclamation"></i> Divergência
                </span>
              </div>
              <div class="pt-card-actions" v-if="patrimony.statusName === 'Locado' && hasRule('Operational')">
                <ButtonMovimentStock
                    :showTitleButton="false"
                    :keyButton="patrimony.patrimonyId"
                    :rentId="group.rentId"
                    :periodRentId="group.periodRentId"
                />
                <Button
                    v-if="group.rentId"
                    :_key="patrimony.patrimonyId + 'edit'"
                    tooltip="Abrir Locação"
                    color="white"
                    backGroundColor="#A9A9A9"
                    classIcon="fa-solid fa-pen-to-square"
                    size="small"
                    :clicked="() => navigateToRent(group.rentId, group.periodRentId, patrimony.patrimonyId)"
                />
              </div>
            </div>

            <div class="pt-empty-moviments" v-if="!patrimony.moviments || patrimony.moviments.length === 0">
              <i class="fa-solid fa-inbox"></i> Nenhuma movimentação registrada.
            </div>

            <ScrollBar v-else :minHeight="200" :maxHeight="260">
              <div class="pt-timeline">
                <div class="pt-tl-item" v-for="(moviment, mIdx) in patrimony.moviments"
                     :key="moviment.itemsRentId || mIdx">
                  <div class="pt-tl-aside">
                    <div :class="['pt-tl-dot', getDotClass(moviment.statusMoviment)]">
                      <i :class="getMovimentIcon(moviment.statusMoviment)"></i>
                    </div>
                    <div class="pt-tl-line" v-if="mIdx < patrimony.moviments.length - 1"></div>
                  </div>

                  <div class="pt-tl-body">
                    <div class="pt-tl-row-top">
                      <span :class="['pt-mov-badge', getBadgeClass(moviment.statusMoviment)]">
                        {{ moviment.statusMovimentName }}
                      </span>
                      <span class="pt-tl-date">
                        <i class="fa-regular fa-clock"></i> {{ moviment.generationDate }}
                        <i class="fa-regular fa-user"></i> {{ moviment.registeredUser }}
                      </span>
                      <span class="pt-tl-rent" v-if="moviment.numberRent">
                        Locação Nº {{ moviment.numberRent }}
                      </span>
                    </div>

                    <div class="pt-tl-product" v-if="moviment.productFullName">
                      {{ moviment.productFullName }}
                    </div>

                    <div class="pt-tl-quantities"
                         v-if="moviment.itemsMovimentQuantity != null || moviment.itemsRentQuantity != null">
                      <span class="pt-qty-tag" v-if="moviment.itemsRentQuantity != null">
                        Quantidade na Locação <strong>{{ moviment.itemsRentQuantity }}</strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </ScrollBar>
          </div>

        </div>
      </div>
    </ScrollBar>
  </div>
</template>

<script>
import ScrollBar from "@nixweb/nixloc-ui/src/component/layout/ScrollBar.vue";
import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button.vue";
import Select from "@nixweb/nixloc-ui/src/component/forms/Select";
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";
import ButtonMovimentStock from "../../operational/ButtonMovimentStock.vue";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

export default {
  name: "PatrimonyTracking",
  components: {ScrollBar, Alert, Button, Select, Loading, ButtonMovimentStock},
  computed: {
    ...mapState("user", ["userLogged"]),
    ...mapGetters("user", ["hasRule"]),
    isUserTemp() {
      return this.userLogged && this.userLogged.user && this.userLogged.user.userName === "UserTemp";
    },
    totalMoviments() {
      if (!this.result || !Array.isArray(this.result)) return 0;
      return this.result.reduce((sum, group) => {
        return sum + (group.patrimonies || []).reduce((s, p) => s + (p.moviments ? p.moviments.length : 0), 0);
      }, 0);
    },
  },
  data() {
    return {
      formName: "patrimonyTracking",
      urlGet: "/api/v1/stock/patrimony-moviment/tracking-by-barcode",
      barCode: "",
      product: {},
      loading: false,
      searched: false,
      result: null,
    };
  },
  methods: {
    ...mapActions("generic", ["getApi"]),
    ...mapMutations("generic", ["removeLoading", "hideModal"]),
    navigateToRent(rentId, periodRentId, keyButton) {
      this.hideModal();
      this.removeLoading([keyButton + 'edit']);
      this.$emit('close');
      this.$router.push({
        name: "rentOperationalUpdate",
        params: {id: rentId, periodRentId: periodRentId},
      });

    },
    search() {
      const code = this.barCode.trim();
      const productId = this.product && this.product.id ? this.product.id : null;
      if (!code) return;
      this.loading = true;
      this.searched = false;
      this.result = null;
      this.getApi({url: this.urlGet, obj: {barCode: code, productId}})
          .then((response) => {
            this.result = Array.isArray(response.content) ? response.content : [];
          })
          .catch(() => {
            this.result = null;
          })
          .finally(() => {
            this.loading = false;
            this.searched = true;
            this.removeLoading(["search-patrimony"]);
          });
    },
    getStatusClass(statusName) {
      const map = {
        "Disponível": "s-disponivel",
        "Locado": "s-locado",
        "Inativo": "s-inativo",
        "Manutenção": "s-manutencao"
      };
      return map[statusName] || "s-default";
    },
    getDotClass(s) {
      return s === 1 ? "dot-locado" : s === 2 ? "dot-retornado" : s === 3 ? "dot-substituido" : "dot-default";
    },
    getBadgeClass(s) {
      return s === 1 ? "badge-locado" : s === 2 ? "badge-retornado" : s === 3 ? "badge-substituido" : "badge-default";
    },
    getMovimentIcon(s) {
      return s === 1 ? "fa-solid fa-arrow-right" : s === 2 ? "fa-solid fa-arrow-left" : s === 3 ? "fa-solid fa-right-left" : "fa-solid fa-circle";
    },
  },
};
</script>

<style scoped>

.pt-root {
  padding: 4px 2px 8px;
}

.pt-product-filter {
  margin-bottom: 12px;
}

.pt-search-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
}

.pt-search-input {
  flex: 1;
  border: 1px solid #e2e5ea;
  border-radius: 50px;
  outline: none;
  background: #fff;
  font-size: 13px;
  padding: 5px 14px;
  color: #1f2937;
}

.pt-search-input::placeholder {
  color: #c4c9d4;
}

.pt-empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #c4c9d4;
}

.pt-empty-icon {
  font-size: 40px;
  margin-bottom: 12px;
  display: block;
}

.pt-empty-text {
  font-size: 13px;
  color: #9aa3b0;
}

.pt-card {
  background: #fff;
  border: 1px solid #eaecf0;
  border-radius: 10px;
  padding: 16px 18px;
  margin-bottom: 14px;
}

.pt-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
  flex-wrap: wrap;
  gap: 8px;
}

.pt-card-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.pt-card-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.pt-barcode-pill {
  background: #eef0f8;
  color: #4338ca;
  padding: 4px 13px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: .03em;
}

.pt-sub-label {
  font-size: 13px;
  color: #b0b8c4;
}

.pt-status-pill {
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 400;
  color: #fff;
}

.s-disponivel {
  background: #38a169;
}

.s-locado {
  background: #00048B;
}

.s-inativo {
  background: #e53e3e;
}

.s-manutencao {
  background: #d97706;
}

.s-default {
  background: #9ca3af;
}

.pt-empty-moviments {
  text-align: center;
  color: #b0b8c4;
  font-size: 13px;
  padding: 16px 0 8px;
}

.pt-timeline {
  padding: 6px 8px 6px 4px;
}

.pt-tl-item {
  display: flex;
  gap: 12px;
}

.pt-tl-aside {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  width: 24px;
}

.pt-tl-dot {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 10px;
  flex-shrink: 0;
}

.dot-locado {
  background: #00048B;
}

.dot-retornado {
  background: #B8860A;
}

.dot-substituido {
  background: #6b7280;
}

.dot-default {
  background: #b0b8c4;
}

.pt-tl-line {
  flex: 1;
  width: 1px;
  background: #eaecf0;
  margin: 3px 0;
  min-height: 20px;
}

.pt-tl-body {
  flex: 1;
  padding-bottom: 20px;
}

.pt-tl-row-top {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 5px;
}

.pt-mov-badge {
  padding: 1px 7px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 400;
  color: #fff;
}

.badge-locado {
  background: #00048B;
}

.badge-saida {
  background: #019183;
}

.badge-retornado {
  background: #B8860A;
}

.badge-substituido {
  background: #6b7280;
}

.badge-default {
  background: #b0b8c4;
}

.pt-tl-date {
  font-size: 11px;
  color: #9aa3b0;
}

.pt-tl-rent {
  background: #6b8cae;
  border: none;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  padding: 4px 12px;
  border-radius: 8px;
  margin-left: auto;
}

.pt-tl-product {
  font-size: 12px;
  color: #374151;
  margin-bottom: 5px;
  line-height: 1.4;
}

.pt-tl-quantities {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 7px;
}

.pt-qty-tag {
  background: #f5f6f8;
  border: 1px solid #eaecf0;
  border-radius: 10px;
  font-size: 12px;
  padding: 2px 9px;
  color: #4b5563;
}

.pt-total-badge {
  display: inline-block;
  background: #f0f1f4;
  border-radius: 50px;
  padding: 6px 18px;
  font-size: 13px;
  color: #374151;
  margin-bottom: 14px;
}

.pt-total-badge strong {
  font-weight: 700;
}

.pt-results-inner {
  padding-right: 4px;
}

.pt-divergence-badge {
  background: #fff3cd;
  color: #92400e;
  border: 1px solid #fde68a;
  padding: 2px 9px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 500;
}

</style>

